export default "__VITE_ASSET__BlDTBq00__"